/*
 * @Author: qh_feng
 * @Date: 2021-12-06 16:13:32
 * @LastEditTime: 2022-12-23 11:03:32
 * @LastEditors: your name
 * @Description:
 * @ FilePath: Do not edit
 * @par 修改日志:
 * 内容:
 */
// 导入组件
import Vue from 'vue'
import Router from 'vue-router'
import store from '@/vuex'

import {
  getIFramePath,
  getIFrameUrl
} from '@/commons/util'
import {
  Message
} from 'element-ui'

// 登录
import J3Klogin from '@/views/J3Klogin'
import HomePage from '@/views/home/HomePage'
import Index from '@/views/index'

/***菜单*** */
//第二个
import DeclareIndex from '@/views/sbgl/index'
import DeclareMenu from '@/views/sbgl/menu'
import Qyxxgl from '@/views/sbgl/qyxxgl'
import Ryxxsb from '@/views/sbgl/ryxxsb'
import Qyclsb from '@/views/sbgl/qyclsb'
import Lsclsb from '@/views/sbgl/lsclsb'
import Clsbsp from '@/views/sbgl/clsbsp'
import Rysbsp from '@/views/sbgl/rysbsp'

import Qyjcsb from '@/views/sbgl/qyjcsb'
import Qykcsb from '@/views/sbgl/qykcsb'
import Qyhcsb from '@/views/sbgl/qyhcsb'
import Lsjcsb from '@/views/sbgl/lsjcsb'
import Lskcsb from '@/views/sbgl/lskcsb'
import Lshcsb from '@/views/sbgl/lshcsb'
import Qyrysb from '@/views/sbgl/qyrysb'
import Lsrysb from '@/views/sbgl/lsrysb'
import Wxpclsb from '@/views/sbgl/wxpclsb'
import Sbclsp from '@/views/sbgl/sbclsp'
import Sbrysp from '@/views/sbgl/sbrysp'
import Tqjcsb from '@/views/sbgl/tqjcsb'
import Tqkcsb from '@/views/sbgl/tqkcsb'
import Tqhcsb from '@/views/sbgl/tqhcsb'
import Tqrysb from '@/views/sbgl/tqrysb'
import Lswxpsb from '@/views/sbgl/lswxpsb'
//第3个
import Rlsj from '@/views/search/rlsj'
import Clzj from '@/views/search/clzj'
import Kksj from '@/views/search/kksj'
import CarMap from '@/views/search/map'
//第4个
import Ssjk from '@/views/mngm/ssjk'
import Lshf from '@/views/mngm/lshf'
import Qjkz from '@/views/mngm/qjkz'
//第5个
import Bkgl from '@/views/yjbk/bkgl'
import Bkgj from '@/views/yjbk/bkgj'
//第6个
import Wxpctj from '@/views/tjfx/wxpctj'
import Xxjctj from '@/views/tjfx/xxjctj'
import Hctj from '@/views/tjfx/hctj'
import Kctj from '@/views/tjfx/kctj'
import Qyrytj from '@/views/tjfx/qyrytj'
import Lsrytj from '@/views/tjfx/lsrytj'
import OverallStatic from '@/views/tjfx/overallStatic'
import CarDeclareApprovalStatic from '@/views/tjfx/carDeclareApprovalStatic'
//第7个
import Gggl from '@/views/xtgl/gggl'
import Aqjyfb from '@/views/xtgl/aqjyfb'
import Zlkgl from '@/views/xtgl/zlkgl'
import Kkgl from '@/views/xtgl/kkgl'
import Sbgl from '@/views/xtgl/sbgl'
import Czrz from '@/views/xtgl/czrz'
import Hmdgl from '@/views/xtgl/hmdgl'
import Gkqy from '@/views/xtgl/gkqy'

//首页右上角菜单系列
import Sysmenu from '@/views/sysmenu'
import DepartmentManagement from '@/views/sysmenu/department-management'
import UserManagement from '@/views/sysmenu/user-management'
import RoleManagement from '@/views/sysmenu/role-management'
import MenuManagement from '@/views/sysmenu/menu-management'
import Qylxrgl from '@/views/sysmenu/qylxrgl'
// 启用路由
Vue.use(Router)
// $router.push跳转到一个相同的路由就会报错，路由时后端渲染跟写死的几个重复了！下面方法为了压制错误
const originalPush = Router.prototype.push
Router.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch(err => err)
}

// 导出路由
const router = new Router({
  linkActiveClass: 'cur',
  routes: [
    {
      path: '/',
      name: '0',
      component: Index,
      iconCls: 'el-icon-tickets',
      redirect: '/index', // 默认转到 index路由
      children: [
        {
          path: '/index',
          //name: 'home',
          name: '206',
          component: HomePage,
          meta: {
            requireAuth: true
          }
        },
        // 第二个菜单重构
        {
          path: "/declare",
          name: "207",
          component: DeclareIndex,
          redirect: '/declare/index',
          children: [
            {
              path: 'index',
              name: '207',
              component: DeclareMenu
            },
            // {
            //     path: 'sbgl-qyxxgl', //企业信息管理
            //     name: 'sbglQyxxgl',
            //     component: Qyxxgl
            // },
            // {
            //     path: 'sbgl-ryxxsb', //人员信息申报
            //     name: 'sbglRyxxsb',
            //     component: Ryxxsb
            // },
            // {
            //     path: 'sbgl-qyclsb', //企业车辆申报
            //     name: 'sbglQyclsb',
            //     component: Qyclsb
            // },
            // {
            //     path: 'sbgl-lsclsb', //临时车辆申报
            //     name: 'sbglLsclsb',
            //     component: Lsclsb
            // },
            // {
            //     path: 'sbgl-clsbsp', //车辆申报审批
            //     name: 'sbglClsbsp',
            //     component: Clsbsp
            // },
            // {
            //     path: 'sbgl-rysbsp', //人员申报审批
            //     name: 'sbglRysbsp',
            //     component: Rysbsp
            // },

            // {
            //     path: 'sbgl-qyjcsb', //小程序企业轿车申报
            //     //name: 'sbglQyjcsb',
            //     name: '208',
            //     component: Qyjcsb
            // },
            // {
            //     path: 'sbgl-qykcsb', //小程序企业客车申报
            //     //name: 'sbglQykcsb',
            //     name: '209',
            //     component: Qykcsb
            // },
            // {
            //     path: 'sbgl-qyhcsb', //小程序企业货车申报
            //     //name: 'sbglQyhcsb',
            //     name: '210',
            //     component: Qyhcsb
            // },
            // {
            //     path: 'sbgl-lsjcsb', //小程序临时轿车申报
            //     //name: 'sbglLsjcsb',
            //     name: '211',
            //     component: Lsjcsb
            // },
            // {
            //     path: 'sbgl-lskcsb', //小程序临时客车申报
            //     //name: 'sbglLskcsb',
            //     name: '212',
            //     component: Lskcsb
            // },
            // {
            //     path: 'sbgl-lshcsb', //小程序临时货车申报
            //     //name: 'sbglLshcsb',
            //     name: '213',
            //     component: Lshcsb
            // },
            // {
            //     path: 'sbgl-qyrysb', //小程序企业人员申报
            //     //name: 'sbglQyrysb',
            //     name: '214',
            //     component: Qyrysb
            // },
            // {
            //     path: 'sbgl-lsrysb', //小程序临时人员申报
            //     //name: 'sbglLsrysb',
            //     name: '215',
            //     component: Lsrysb
            // },
            // {
            //     path: 'sbgl-wxpclsb', //小程序危险品车辆申报
            //     //name: 'sbglWxpclsb',
            //     name: '216',
            //     component: Wxpclsb
            // },
            // {
            //     path: 'sbgl-sbclsp', //小程序车辆申报审批
            //     //name: 'sbglSbclsp',
            //     name: '217',
            //     component: Sbclsp
            // },
            // {
            //     path: 'sbgl-sbrysp', //小程序人员申报审批
            //     //name: 'sbglSbrysp',
            //     name: '218',
            //     component: Sbrysp
            // },
            // {
            //     path: '/sbgl-tqjcsb', //小程序通勤轿车申报

            //     name: '262',
            //     component: Tqjcsb
            // },
            // {
            //     path: '/sbgl-tqkcsb', //小程序通勤客车申报

            //     name: '263',
            //     component: Tqkcsb
            // },
            // {
            //     path: '/sbgl-tqhcsb', //小程序通勤货车申报

            //     name: '264',
            //     component: Tqhcsb
            // },
            // {
            //     path: '/sbgl-tqrysb', //小程序通勤人员申报

            //     name: '265',
            //     component: Tqrysb
            // },
            // {
            //     path: '/sbgl-lswxpsb', //小程序临时危险品车辆申报

            //     name: '261',
            //     component: Lswxpsb
            // }
          ]
        },
        // //第三个菜单子项
        // {
        //     path: '/search-rlsj',  //人脸数据检索
        //     //name: 'searchRlsj',
        //     name: '220',
        //     component: Rlsj
        // },
        // {
        //     path: '/search-clzj',  //车辆闸机检索
        //     //name: 'searchClzj',
        //     name: '221',
        //     component: Clzj
        // },
        // {
        //     path: '/search-kksj',  //卡口数据检索
        //     //name: 'searchKksj',
        //     name: '222',
        //     component: Kksj
        // },
        // {
        //     path: '/search-map',  //车辆轨迹
        //     //name: 'searchMap',
        //     name: '223',
        //     component: CarMap
        // },
        // //第四个菜单子项
        // {
        //     path: '/mngm-ssjk',
        //     //name: 'mngmSsjk',
        //     name: '225',
        //     component: Ssjk
        // },
        // {
        //     path: '/mngm-lshf',
        //     //name: 'mngmLshf',
        //     name: '226',
        //     component: Lshf
        // },
        // {
        //     path: '/mngm-qjkz',
        //     //name: 'mngmQjkz',
        //     name: '227',
        //     component: Qjkz,
        // },
        // //第五个菜单子项
        // {
        //     path: '/yjbk-bkgl',
        //     //name: 'yjbkBkgl',
        //     name: '229',
        //     component: Bkgl
        // },
        // {
        //     path: '/yjbk-bkgj',
        //     //name: 'yjbkBkgj',
        //     name: '230',
        //     component: Bkgj
        // },
        // //第六个菜单子项
        // {
        //     path: '/tjfx-wxpctj',
        //     //name: 'tjfxWxpctj',
        //     name: '232',
        //     component: Wxpctj
        // },
        // {
        //     path: '/tjfx-xxjctj',
        //     //name: 'tjfxXxjctj',
        //     name: '233',
        //     component: Xxjctj
        // },
        // {
        //     path: '/tjfx-hctj',
        //     //name: 'tjfxHctj',
        //     name: '234',
        //     component: Hctj
        // },
        // {
        //     path: '/tjfx-kctj',
        //     //name: 'tjfxKctj',
        //     name: '235',
        //     component: Kctj
        // },
        // {
        //     path: '/tjfx-qyrytj',
        //     //name: 'tjfxQyrytj',
        //     name: '236',
        //     component: Qyrytj
        // },
        // {
        //     path: '/tjfx-lsrytj',
        //     //name: 'tjfxLsrytj',
        //     name: '237',
        //     component: Lsrytj
        // },
        // //第7个菜单子项
        // {
        //     path: '/xtgl-gggl',
        //     //name: 'xtglGggl',
        //     name: '239',
        //     component: Gggl
        // },
        // {
        //     path: '/xtgl-aqjyfb',
        //     //name: 'xtglAqjyfb',
        //     name: '240',
        //     component: Aqjyfb
        // },
        // {
        //     path: '/xtgl-zlkgl',
        //     //name: 'xtglZlkgl',
        //     name: '241',
        //     component: Zlkgl,
        // },
        // {
        //     path: '/xtgl-kkgl',
        //     //name: 'xtglKkgl',
        //     name: '242',
        //     component: Kkgl
        // },
        // {
        //     path: '/xtgl-sbgl',
        //     //name: 'xtglSbgl',
        //     name: '243',
        //     component: Sbgl
        // },
        // {
        //     path: '/sbgl-qyxxgl', //企业信息管理
        //     name: '255',
        //     component: Qyxxgl
        // },
        // {
        //     path: '/xtgl-hmdgl', //车牌黑名单管理
        //     name: '268',
        //     component: Hmdgl
        // },
        // {
        //     path: '/xtgl-czrz', //操作日志管理
        //     name: '269',
        //     component: Czrz
        // },
        // {
        //     path: '/sysmenu',
        //     name: 'sysmenu',
        //     component: Sysmenu,
        //     // redirect: '/index',
        //     children: [
        //         {
        //             path: '/sysmenu/department-management',
        //             //name: 'departmentManagement',
        //             name: '244',
        //             component: DepartmentManagement
        //         },
        //         {
        //             path: '/sysmenu/user-management',
        //             //name: 'userManagement',
        //             name: '245',
        //             component: UserManagement
        //         },
        //         {
        //             path: '/sysmenu/role-management',
        //             //name: 'roleManagement',
        //             name: '246',
        //             component: RoleManagement
        //         },
        //         {
        //             path: '/sysmenu/menu-management',
        //             //name: 'menuManagement',
        //             name: '247',
        //             component: MenuManagement
        //         },
        //         {
        //             path: '/sysmenu/qylxrgl',
        //             //name: 'xtglQylxrgl',
        //             name: '256',
        //             component: Qylxrgl
        //         },
        //     ]
        // },
      ]
    },

    {
      path: '/J3Klogin',
      name: 'login',
      component: J3Klogin,
      params: {
        a: 'abcd'
      },
      hidden: true,
      meta: {
        requireAuth: false
      }
    }

  ]
})

let publicRouter1 ={
  path: '/',
  name: '0',
  component: Index,
  iconCls: 'el-icon-tickets',
  redirect: '/index', // 默认转到 index路由
  children: [
    {
      path: '/index',
      name: '206',
      component: HomePage,
      meta: {
        requireAuth: true
      }
    },
    {
      path: "/declare",
      name: "207",
      component: DeclareIndex,
      redirect: '/declare/index',
      children: [
        {
          path: 'index',
          name: '207',
          component: DeclareMenu
        },
      ]
    },
    {
      path: '/tjfx-overallStatic',
      name: '273',
      component: OverallStatic,
      meta: {
        requireAuth: true
      }
    },
    {
      path: '/tjfx-carDeclareApprovalStatic',
      name: '275',
      component: CarDeclareApprovalStatic,
      meta: {
        requireAuth: true
      }
    },
    {
      path: '/xtgl-gkqy',
      name: '274',
      component: Gkqy,
      meta: {
        requireAuth: true
      }
    },
  ]
}

let publicRouter2 = {
  path: '/J3Klogin',
  name: 'login',
  component: J3Klogin,
  params: {
    a: 'abcd'
  },
  hidden: true,
  meta: {
    requireAuth: false
  }
}

window.localStorage.setItem('storageAside', '0')
// 路由拦截器
router.beforeEach((to, from, next) => {
  store.commit('SET_WEBTITLE', to.name) // 设置标题
/*
  console.log('检查noToken参数，当前路由query:', to.query);
  const noToken = to.query.noToken;
  console.log('获取到的noToken参数:', noToken);
  if (noToken == 'true') {
    let user = {
      "access_token": "eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJvdGhlckluZm8iOiIiLCJ1c2VyX25hbWUiOiJoYWRtaW4iLCJjb19pZCI6NzgsIm1vYmlsZSI6IjEzNTc1Nzk1NzA3Iiwicm9sZVR5cGUiOjEsImF1dGhvcml0aWVzIjpbNTldLCJjbGllbnRfaWQiOiJkcWktYWRtaW4iLCJ1c2VyX2lkIjo3NzA0LCJzY29wZSI6WyJhbGwiXSwibmlja25hbWUiOiLnjrDlnLrnlKjmiLciLCJleHAiOjE3NTA5MDczNTEsImp0aSI6Ijg3M2EwMGExLWVkZTItNDRkZC1iMGFkLWYwMTk3ZGQ4Nzk4NSIsInVzZXJuYW1lIjoiaGFkbWluIn0.MmVPAgcJgb17zOSmi5krTuCbppDJDP8AO0kOfFIH1ZiRzclun0LlqffaIa56W3DDR0nDSQrhlclBe5w-ParZtjbJlYOPKQVwTNHHYQr8FMbupvHXXe-Lr79m3BViXWEzdpbHuOMWsYRDqfudz_HC5jTyF1iZ6WGpYvex-AYaYltLaTxtirINAsT_Q6iWY2b7dao8EkdIgjJaY92cMSfZJF3_LYNZcPK6bik5rOlBKhdeYwyGuTiN41-FXu1OYNabVj6Kf1IYoUNpYIXS60bnNjyBuHnrgvO7jB_2qcKutHDXKVi6epJJFk1oWQ8orUOGpJvyLDnE8W7aGwbfz9wukA",
      "token_type": "bearer",
      "refresh_token": "eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJvdGhlckluZm8iOiIiLCJ1c2VyX25hbWUiOiJoYWRtaW4iLCJjb19pZCI6NzgsIm1vYmlsZSI6IjEzNTc1Nzk1NzA3Iiwicm9sZVR5cGUiOjEsImF1dGhvcml0aWVzIjpbNTldLCJjbGllbnRfaWQiOiJkcWktYWRtaW4iLCJ1c2VyX2lkIjo3NzA0LCJzY29wZSI6WyJhbGwiXSwiYXRpIjoiODczYTAwYTEtZWRlMi00NGRkLWIwYWQtZjAxOTdkZDg3OTg1Iiwibmlja25hbWUiOiLnjrDlnLrnlKjmiLciLCJleHAiOjE3NTA5MDczNTEsImp0aSI6IjNkYmQ3NjViLTkyOGYtNGM1Mi05NzU5LTNiODE4YTJlZTMyZiIsInVzZXJuYW1lIjoiaGFkbWluIn0.GNLbcyDg_g1O4XoFCkk7hTgeNlorrOXFaz_7scRmoTBMUnyXJylE_yG6423Hi2CPKVNISeCTZo888NC1eAmsiwkIfxApv5Tp2kaXxpSs71HlNRMoqUsnexwbmzM7NqVZntWbm4slNqpLD7m6wp0vnD_Cu7mfFxRuFrQiEh1FojNgVEU8fJ9ruYnRB9rYDIjYtkwmZzgurmQx-U6vDuYdVmuaU0YdvoNl1rjEBX4eU3bAsrtIe4uuK7NCE5hLwxfw5zyHBxVajCEsIwRlaxaiwecMPfZ6sQp8B2cOuP5Fyoqf60xz0ktbPtqnMzMN48q_waRuPKEmnt4DCo1W2iAP1A",
      "expires_in": 99999999999999999,
      "scope": "all",
      "otherInfo": "",
      "user_id": "7704",
      "co_id": "78",
      "nickname": "现场用户",
      "mobile": "13575795707",
      "roleType": 1,
      "client_id": "dqi-admin",
      "authorities": [
        "59"
      ],
      "username": "hadmin",
      "jti": "873a00a1-ede2-44dd-b0ad-f0197dd87985"
    }
    window.localStorage.setItem("MP_ACCESS_TOKEN", "eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJvdGhlckluZm8iOiIiLCJ1c2VyX25hbWUiOiJoYWRtaW4iLCJjb19pZCI6NzgsIm1vYmlsZSI6IjEzNTc1Nzk1NzA3Iiwicm9sZVR5cGUiOjEsImF1dGhvcml0aWVzIjpbNTldLCJjbGllbnRfaWQiOiJkcWktYWRtaW4iLCJ1c2VyX2lkIjo3NzA0LCJzY29wZSI6WyJhbGwiXSwibmlja25hbWUiOiLnjrDlnLrnlKjmiLciLCJleHAiOjE3NTA5MDczNTEsImp0aSI6Ijg3M2EwMGExLWVkZTItNDRkZC1iMGFkLWYwMTk3ZGQ4Nzk4NSIsInVzZXJuYW1lIjoiaGFkbWluIn0.MmVPAgcJgb17zOSmi5krTuCbppDJDP8AO0kOfFIH1ZiRzclun0LlqffaIa56W3DDR0nDSQrhlclBe5w-ParZtjbJlYOPKQVwTNHHYQr8FMbupvHXXe-Lr79m3BViXWEzdpbHuOMWsYRDqfudz_HC5jTyF1iZ6WGpYvex-AYaYltLaTxtirINAsT_Q6iWY2b7dao8EkdIgjJaY92cMSfZJF3_LYNZcPK6bik5rOlBKhdeYwyGuTiN41-FXu1OYNabVj6Kf1IYoUNpYIXS60bnNjyBuHnrgvO7jB_2qcKutHDXKVi6epJJFk1oWQ8orUOGpJvyLDnE8W7aGwbfz9wukA");
    window.localStorage.setItem("userInfo", JSON.stringify(user));
    window.localStorage.setItem("menu", JSON.stringify([{"id":"206","parentId":"0","name":"首页","sort":0,"visible":1,"keepAlive":0},{"id":"207","parentId":"0","name":"申报管理","sort":1,"visible":1,"keepAlive":0,"children":[{"id":"267","parentId":"207","name":"人员申报","sort":0,"visible":1,"keepAlive":0,"declareType":"5","type":"declare","children":[{"id":"214","parentId":"267","name":"企业人员申报","path":"/sbgl-qyrysb","component":"/sbgl/qyrysb","sort":3,"visible":1,"keepAlive":0,"declareType":"1","vehicleType":"5"},{"id":"265","parentId":"267","name":"通勤人员申报","path":"/sbgl-tqrysb","component":"/sbgl/tqrysb","sort":3,"visible":1,"keepAlive":0,"declareType":"3","vehicleType":"5"},{"id":"215","parentId":"267","name":"临时人员申报","path":"/sbgl-lsrysb","component":"/sbgl/lsrysb","sort":4,"visible":1,"keepAlive":0,"declareType":"2","vehicleType":"5","type":"Temp"}]},{"id":"266","parentId":"207","name":"申报审批","sort":0,"visible":1,"keepAlive":0,"type":"approval","children":[{"id":"217","parentId":"266","name":"车辆申报审批","path":"/sbgl-sbclsp","component":"/sbgl/sbclsp","sort":0,"visible":1,"keepAlive":0,"vehicleType":"1234"},{"id":"218","parentId":"266","name":"人员申报审批","path":"/sbgl-sbrysp","component":"/sbgl/sbrysp","sort":1,"visible":1,"keepAlive":0,"vehicleType":"5"}]},{"id":"257","parentId":"207","name":"企业申报","sort":0,"visible":1,"keepAlive":0,"declareType":"1","type":"declare","children":[{"id":"208","parentId":"257","name":"企业轿车申报","path":"/sbgl-qyjcsb","component":"/sbgl/qyjcsb","sort":0,"visible":1,"keepAlive":0,"declareType":"1","vehicleType":"1"},{"id":"209","parentId":"257","name":"企业客车申报","path":"/sbgl-qykcsb","component":"/sbgl/qykcsb","sort":1,"visible":1,"keepAlive":0,"declareType":"1","vehicleType":"2"},{"id":"210","parentId":"257","name":"企业货车申报","path":"/sbgl-qyhcsb","component":"/sbgl/qyhcsb","sort":2,"visible":1,"keepAlive":0,"declareType":"1","vehicleType":"3"}]},{"id":"258","parentId":"207","name":"通勤申报","sort":1,"visible":1,"keepAlive":0,"declareType":"3","type":"declare","children":[{"id":"262","parentId":"258","name":"通勤轿车申报","path":"/sbgl-tqjcsb","component":"/sbgl/tqjcsb","sort":0,"visible":1,"keepAlive":0,"declareType":"3","vehicleType":"1"},{"id":"263","parentId":"258","name":"通勤客车申报","path":"/sbgl-tqkcsb","component":"/sbgl/tqkcsb","sort":1,"visible":1,"keepAlive":0,"declareType":"3","vehicleType":"2"},{"id":"264","parentId":"258","name":"通勤货车申报","path":"/sbgl-tqhcsb","component":"/sbgl/tqhcsb","sort":2,"visible":1,"keepAlive":0,"declareType":"3","vehicleType":"3"}]},{"id":"259","parentId":"207","name":"危化品车申报","sort":2,"visible":1,"keepAlive":0,"declareType":"4","type":"declare","children":[{"id":"216","parentId":"259","name":"企业危化品车申报","path":"/sbgl-wxpclsb","component":"/sbgl/wxpclsb","sort":0,"visible":1,"keepAlive":0,"declareType":"1","vehicleType":"4"},{"id":"261","parentId":"259","name":"临时危化品车申报","path":"/sbgl-lswxpsb","component":"/sbgl/lswxpsb","sort":1,"visible":1,"keepAlive":0,"declareType":"2","vehicleType":"4"}]},{"id":"260","parentId":"207","name":"临时申报","sort":3,"visible":1,"keepAlive":0,"declareType":"2","type":"declare","children":[{"id":"211","parentId":"260","name":"临时轿车申报","path":"/sbgl-lsjcsb","component":"/sbgl/lsjcsb","sort":1,"visible":1,"keepAlive":0,"declareType":"2","vehicleType":"1","type":"Temp"},{"id":"212","parentId":"260","name":"临时客车申报","path":"/sbgl-lskcsb","component":"/sbgl/lskcsb","sort":2,"visible":1,"keepAlive":0,"declareType":"2","vehicleType":"2","type":"Temp"},{"id":"213","parentId":"260","name":"临时货车申报","path":"/sbgl-lshcsb","component":"/sbgl/lshcsb","sort":3,"visible":1,"keepAlive":0,"declareType":"2","vehicleType":"3","type":"Temp"}]}]},{"id":"219","parentId":"0","name":"查询检索","sort":2,"visible":1,"keepAlive":0,"children":[{"id":"220","parentId":"219","name":"人脸数据检索","path":"/search-rlsj","component":"/search/rlsj","sort":0,"visible":1,"keepAlive":0},{"id":"221","parentId":"219","name":"车辆闸机检索","path":"/search-clzj","component":"/search/clzj","sort":1,"visible":1,"keepAlive":0},{"id":"222","parentId":"219","name":"卡口数据检索","path":"/search-kksj","component":"/search/kksj","sort":2,"visible":1,"keepAlive":0},{"id":"223","parentId":"219","name":"车辆轨迹","path":"/search-map","component":"/search/map","sort":3,"visible":1,"keepAlive":0}]},{"id":"224","parentId":"0","name":"设备监控","sort":3,"visible":1,"keepAlive":0,"children":[{"id":"225","parentId":"224","name":"实时监控","path":"/mngm-ssjk","component":"/mngm/ssjk","sort":0,"visible":1,"keepAlive":0},{"id":"226","parentId":"224","name":"历史回放","path":"/mngm-lshf","component":"/mngm/lshf","sort":1,"visible":1,"keepAlive":0},{"id":"227","parentId":"224","name":"球机控制","path":"/mngm-qjkz","component":"/mngm/qjkz","sort":2,"visible":1,"keepAlive":0}]},{"id":"231","parentId":"0","name":"统计分析","sort":5,"visible":1,"keepAlive":0,"children":[{"id":"232","parentId":"231","name":"危险品车统计","path":"/tjfx-wxpctj","component":"/tjfx/wxpctj","sort":0,"visible":1,"keepAlive":0},{"id":"233","parentId":"231","name":"小型轿车统计","path":"/tjfx-xxjctj","component":"/tjfx/xxjctj","sort":0,"visible":1,"keepAlive":0},{"id":"234","parentId":"231","name":"货车统计","path":"/tjfx-hctj","component":"/tjfx/hctj","sort":0,"visible":1,"keepAlive":0},{"id":"235","parentId":"231","name":"客车统计","path":"/tjfx-kctj","component":"/tjfx/kctj","sort":0,"visible":1,"keepAlive":0},{"id":"237","parentId":"231","name":"临时人员统计","path":"/tjfx-lsrytj","component":"/tjfx/lsrytj","sort":0,"visible":1,"keepAlive":0},{"id":"236","parentId":"231","name":"企业人员统计","path":"/tjfx-qyrytj","component":"/tjfx/qyrytj","sort":0,"visible":1,"keepAlive":0}]},{"id":"238","parentId":"0","name":"系统管理","sort":6,"visible":1,"keepAlive":0,"children":[{"id":"245","parentId":"238","name":"用户管理","path":"/sysmenu/user-management","component":"/sysmenu/user-management","sort":0,"visible":1,"keepAlive":0},{"id":"239","parentId":"238","name":"公告管理","path":"/xtgl-gggl","component":"/xtgl/gggl","sort":0,"visible":1,"keepAlive":0},{"id":"240","parentId":"238","name":"安全教育发布","path":"/xtgl-aqjyfb","component":"/xtgl/aqjyfb","sort":0,"visible":1,"keepAlive":0},{"id":"241","parentId":"238","name":"资料库管理","path":"/xtgl-zlkgl","component":"/xtgl/zlkgl","sort":0,"visible":1,"keepAlive":0},{"id":"242","parentId":"238","name":"卡口管理","path":"/xtgl-kkgl","component":"/xtgl/kkgl","sort":0,"visible":1,"keepAlive":0},{"id":"243","parentId":"238","name":"设备管理","path":"/xtgl-sbgl","component":"/xtgl/sbgl","sort":0,"visible":1,"keepAlive":0},{"id":"244","parentId":"238","name":"部门管理","path":"/sysmenu/department-management","component":"/sysmenu/department-management","sort":0,"visible":1,"keepAlive":0},{"id":"246","parentId":"238","name":"角色管理","path":"/sysmenu/role-management","component":"/sysmenu/role-management","sort":0,"visible":1,"keepAlive":0},{"id":"247","parentId":"238","name":"菜单管理","path":"/sysmenu/menu-management","component":"/sysmenu/menu-management","sort":0,"visible":1,"keepAlive":0},{"id":"255","parentId":"238","name":"企业信息管理","path":"/xtgl-qyxxgl","component":"/sbgl/qyxxgl","sort":0,"visible":1,"keepAlive":0},{"id":"256","parentId":"238","name":"企业联系人管理","path":"/sysmenu/qylxrgl","component":"/sysmenu/qylxrgl","sort":0,"visible":1,"keepAlive":0},{"id":"268","parentId":"238","name":"黑名单管理","path":"/xtgl-hmdgl","component":"/xtgl/hmdgl","sort":0,"visible":1,"keepAlive":0},{"id":"272","parentId":"238","name":"企业申报车辆","path":"/sysmenu/qysbcl","component":"/sysmenu/qysbcl","sort":0,"visible":1,"keepAlive":0},{"id":"269","parentId":"238","name":"操作日志","path":"/xtgl-czrz","component":"/xtgl/czrz","sort":1,"visible":1,"keepAlive":0}]}]));
    console.log('已在路由守卫中设置固定token值');
  }*/
  setTimeout(() => {
    document.title = to.path == '/J3Klogin' ? '海盐经济开发区化工园区封闭管理系统' : (store.state.documentTitle ? store.state.documentTitle[to.name] : '') + (store.state.documentTitle_menuName && store.state.documentTitle_menuName[to.name] ? ("-" + store.state.documentTitle_menuName[to.name]) : '')
  }, 100)
  const userInfo = window.localStorage.getItem('userInfo')
  console.log('路由拦截,获取用户信息',userInfo)
  if (to.path === '/J3Klogin') {
    if (userInfo) {
      next({
        path: '/index'
      })

    } else {
      next()
    }
  } else {
    if (!userInfo) {
      // 如果访问非登录界面，且户会话信息不存在，代表未登录，则跳转到登录界面
      next({
        path: '/J3Klogin'
      })
    } else {
      // 加载动态菜单和路由
      addDynamicMenuAndRoutes()
      let _routeList = store.getters.GET_ROUTELIST
      if (_routeList && _routeList.length === 0) {
        _routeList = window.localStorage.routeList
      }

      if (_routeList && _routeList.length > 0) {
        if (_routeList.indexOf(to.path.toLowerCase()) > -1) {
          next()
        } else {
          if (to.name) {
            Message({
              message: '您没有权限访问当前页面[' + to.name + ']',
              type: 'error'
            })
          } else {
            next('/404')
          }
        }
      } else if(window.localStorage.getItem('storageAside') === '0'){
        window.localStorage.setItem('storageAside', '1')
        router.matcher = new Router().matcher
        router.addRoute(publicRouter1)
        router.addRoute(publicRouter2)
        setTimeout(() => {
          let menus = JSON.parse(localStorage.getItem('menu'))
          //根据权限动态添加路由
          menus.forEach(v => {
            if(v.children){
              if(v.id == 207){
                v.children.forEach(c =>{
                  c.children.forEach(c2 =>{
                    router.addRoute('0',{path: c2.path, name: c2.id,component:()=>import('@/views'+c2.component)})
                  })
                })
              }else{
                v.children.forEach(c =>{
                  router.addRoute('0',{path: c.path, name: c.id,component:()=>import('@/views'+c.component)})
                })
              }
            }
          })
        }, 1000);
        console.log(router.getRoutes())
        next({path: `${to.path}`})
      }else{
        next()
      }
    }
  }
})

/**
 * 加载动态菜单和路由
 */
function addDynamicMenuAndRoutes() {

  /*  if (store.state.app.menuList.length > 0) {
      console.log('菜单与路由已经创建.')
      return
    } */
  // const isLoad = router.app.$store.getters.getIsLoadRoute
  const isLoad = store.getters.GET_IS_LOADROUTE
  if (isLoad) {
    console.log('菜单与路由已经创建.')
    return
  }
  store.commit('SET_IS_LOADROUTE', true) // 是否已经请求加载菜单权限

  // http.sys
  //   .GET_MENU()
  //   .then(res => {
  //     if (res.status === 'S') {
  //       store.commit('SAVE_MENULIST', res.data)
  //       // 添加动态路由
  //       const dynamicRoutes = addDynamicRoutes(res.data)
  //       router.options.routes[0].children = router.options.routes[0].children.concat(
  //         dynamicRoutes
  //       )

  //       store.commit('SET_PERMISSIONS', permissions) // 保存权限
  //       router.addRoutes(router.options.routes)
  //       // 把当前所有的可访问的路径保存在一个数组里
  //       createdPath(router.options.routes)
  //     } else {
  //       console.log(res.msg)
  //     }
  //   })
  //   .catch(error => {
  //     Message({
  //       showClose: true,
  //       message: error,
  //       type: 'error'
  //     })
  //   })
}

const routeList = []
const permissions = [] // 当前用户的按钮功能

// 创建整个路由的列表 ，用来查看是否有访问页面的权限
function createdPath(attr) {
  attr.forEach(item => {
    let route = item.path.indexOf('/') === 0 ? item.path : '/' + item.path
    route = route.toLowerCase()
    routeList.indexOf(route) === -1 && routeList.push(route)
    item.children && createdPath(item.children)
  })

  // 保存所有路由为一个数组
  store.commit('SET_ROUTELIST', routeList)
  window.localStorage.routeList = JSON.stringify(routeList)
}

/**
 * 添加动态(菜单)路由
 * @param {*} menuList 菜单列表
 * @param {*} routes 递归创建的动态(菜单)路由
 */
function addDynamicRoutes(menuList = [], routes = []) {
  var temp = []
  for (var i = 0; i < menuList.length; i++) {
    const item = menuList[i]
    if (item.menus && item.menus.length >= 1) {
      temp = temp.concat(item.menus)
    }
    if (item.url && /\S/.test(item.url)) {
      item.url = item.url.replace(/^\//, '')
      // 创建路由配置
      var route = {
        path: item.url,
        component: null,
        name: item.menuName,
        meta: {
          icon: item.icon,
          index: item.menuId,
          requireAuth: item.requireAuth
        }
      }
      const path = getIFramePath(item.url)
      if (path) {
        // 如果是嵌套页面, 通过iframe展示
        route['path'] = path

        route['component'] = resolve => require([`@/views/layout/IFrame`], resolve)

        // 存储嵌套页面路由路径和访问URL
        const url = getIFrameUrl(item.url)
        const iFrameUrl = {
          path: path,
          url: url
        }
        store.commit('addIFrameUrl', iFrameUrl)
      } else {
        try {
          // 根据菜单URL动态加载vue组件，这里要求vue组件须按照url路径存储
          // 如url="sys/user"，则组件路径应是"@/views/sys/user.vue",否则组件加载不到注意大小写
          let url = item.url
          const arrayUrl = url.split('/')
          const n = arrayUrl.length - 1

          arrayUrl[n] =
            arrayUrl[n].substring(0, 1).toUpperCase() +
            arrayUrl[n].substring(1) // 组件名是大写
          url = arrayUrl.join('/')

          route['component'] = resolve => require([`@/views/${url}`], resolve)
        } catch (e) {
          console.log(e)
        }
      }
      routes.push(route)
    }
    // 获取权限
    if (item.hasThird === 'Y') {
      // 当前为按钮功能
      permissions.push(item.menuId)
    }
  }


  if (temp.length >= 1) {
    addDynamicRoutes(temp, routes)
  } else {
    console.log('动态路由加载...')
    // console.log(routes)
    console.log('动态路由加载完成.')
  }
  return routes
}


export default router



// WEBPACK FOOTER //
// ./src/router/index.js